import { type Car, type CarFeature } from '@prisma/client'
import { Separator } from '#app/shared/ui/data-display/Separator.js'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Accordion } from '#app/shared/ui/surfaces/Accordion.js'
import AccordionSlides from './accordionSlides'

interface EquipmentsProps {
  id: string
  car: Car & {
    features: CarFeature[]
  }
}

const categoryConfig = {
  Seguridad: {
    icon: '/img/accordion/shield-tick.svg',
    label: 'Seguridad',
  },
  Comfort: {
    icon: '/img/accordion/Group 198.svg',
    label: 'Confort',
  },
  Interior: {
    icon: '/img/accordion/calendar-check-02 (6).svg',
    label: 'Interior',
  },
  Exterior: {
    icon: '/img/accordion/calendar-check-02 (7).svg',
    label: 'Exterior',
  },
  'Multimedia y audio': {
    icon: '/img/accordion/tv-01.svg',
    label: 'Multimedia y audio',
  },
  'Otros accesorios': {
    icon: '/img/accordion/calendar-check-02 (6).svg',
    label: 'Otros accesorios',
  },
}
const categoryOrder = Object.keys(categoryConfig)

export default function Equipments({ id, car }: EquipmentsProps) {
  const availableCategories = [
    ...new Set(
      car.features
        .filter((feature) => feature.isActive)
        .map((feature) => feature.category),
    ),
  ]

  const orderedCategories = categoryOrder.filter((category) =>
    availableCategories.includes(category),
  )

  const accordionItems = orderedCategories.map((category) => ({
    trigger: (
      <div className="flex items-center gap-2">
        <img
          className="w-5 h-5"
          src={categoryConfig[category as keyof typeof categoryConfig].icon}
          alt="accordion"
        />
        <p className="text-neutral-900 text-h5-bold">
          {categoryConfig[category as keyof typeof categoryConfig].label}
        </p>
      </div>
    ),
    content: <AccordionSlides features={car.features} category={category} />,
  }))

  return (
    <div className="bg-white" id={id}>
      <Spacer size="40px" />
      <p
        className={`
          ml-4 text-h4 text-neutral-900

          lg:ml-7
        `}
      >
        Equipamiento
      </p>
      <Spacer size="24px" />
      <div
        className={`
          px-4

          sm:px-0
        `}
      >
        <Separator className="h-[2px] bg-neutral-75" />
      </div>
      <div className={`pt-2.5`}>
        {accordionItems.length > 0 ? (
          <Accordion
            accordionItems={accordionItems}
            variant="faq"
            className="flex w-full flex-col"
          />
        ) : (
          <p className="py-4 text-center text-neutral-500">
            No hay equipamiento disponible para este vehículo
          </p>
        )}
      </div>
    </div>
  )
}
